import { faTimes } from '@fortawesome/free-solid-svg-icons';
import propTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import { CLOSE } from '../../config/text/text';
import { isGiftPack } from '../../helpers/vouchers';
import Icon from '../Icon';
import VoucherGiftForm from './VoucherGiftForm';
import VoucherGiftPackForm from './VoucherGiftPackForm';
import { DEFAULT_EVENT_KEY, GIFTING_EVENT_KEY } from './constants';

const VoucherAccordionGifting = ({ voucher, setToggle, mutate }) => {
  const isGiftPacked = isGiftPack(voucher.giftType);

  return (
    <>
      <Accordion.Collapse eventKey={GIFTING_EVENT_KEY}>
        <div className="gifting-wrapper">
          <div className="gifting-header">
            <button
              aria-label={CLOSE}
              className="gifting-close"
              data-testid="gifting-close-button"
              onClick={() => setToggle(DEFAULT_EVENT_KEY)}
              type="button"
            >
              <Icon faIcon={faTimes} />
            </button>
          </div>
          <div className="gifting-body">
            {isGiftPacked && (
              <VoucherGiftPackForm
                mutate={mutate}
                setToggle={setToggle}
                voucher={voucher}
              />
            )}
            {!isGiftPacked && (
              <VoucherGiftForm
                mutate={mutate}
                setToggle={setToggle}
                voucher={voucher}
              />
            )}
          </div>
        </div>
      </Accordion.Collapse>
      <style jsx>{`
        .gifting-wrapper {
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
          margin-bottom: 14px;
        }
        .gifting-header {
          display: flex;
          flex-direction: row-reverse;
          padding: 10px;
        }
        .gifting-body {
          margin-bottom: 14px;
        }
        .gifting-close {
          background-color: transparent;
          border: none;
        }
      `}</style>
    </>
  );
};

VoucherAccordionGifting.propTypes = {
  mutate: propTypes.func,
  setToggle: propTypes.func.isRequired,
  voucher: propTypes.object,
};

export default VoucherAccordionGifting;
